export const charterFeederPricesQueryKeys = {
  all: ['flights-charter', 'charter-feeder-prices'] as const,
  list: () => [...charterFeederPricesQueryKeys.all, 'list'] as const,
};
